/**
 * App JWT store — in-memory only.
 *
 * The JWT is issued by the backend and also set as an httpOnly cookie (the
 * primary auth credential for all API requests). This module keeps a copy in
 * memory so the frontend can inspect expiry and pass it to Bearer-header calls
 * during the same page session. It is NEVER written to localStorage or any
 * browser storage: the httpOnly cookie handles persistence across page refreshes.
 */
let _memCache: string | null = null;

/** Store the bearer token in memory for the current page session. */
export const setAccessToken = (token: string | null): void => {
  _memCache = token?.trim() || null;
};

/** Return the current bearer token from the in-memory cache. */
export const getAccessToken = (): string | null => _memCache;

/** Remove the token — called on sign-out or when the session endpoint returns the token. */
export const clearAccessToken = (): void => {
  _memCache = null;
};
